var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('loader'):(_vm.error)?_c('div',[_c('server-error')],1):_c('div',{staticClass:"eoy2025-page"},[_c('dynamic-component-viewer',{ref:"dynamicComponentViewer",attrs:{"component-name":_vm.componentName,"extra-params":_vm.extraParams}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }